import React from 'react'
import {
  Step,
  StepLabel,
  Stepper as MuiStepper,
  useMediaQuery,
  StepButton,
} from '@material-ui/core'

import useCookieBanner from 'hooks/useCookieBanner'
import constants from 'constants/index'
import theme from 'theme'

const Stepper = () => {
  const { activeStep, goToStep } = useCookieBanner()
  const matches = useMediaQuery(theme.breakpoints.up('lg'))

  const steps = constants.cookies.banner.BANNER_CONFIGURATION_STEPS

  return (
    <MuiStepper
      activeStep={activeStep}
      orientation={matches ? 'horizontal' : 'vertical'}
      nonLinear
    >
      {steps.map((stepConfig, index) => (
        <Step key={stepConfig.step}>
          <StepButton onClick={() => goToStep(index)} id={stepConfig.buttonId}>
            <StepLabel>{stepConfig.step}</StepLabel>
          </StepButton>
        </Step>
      ))}
    </MuiStepper>
  )
}

export default Stepper
